
export default {
  props: {
    content: {
      type: String,
      default: '',
    },
  },
}
